import {
  MAX_PRODUCTION_ORDER_SHEET_TEXT_LENGTH,
  type ProductionOrderSheetFields,
} from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { FormField } from '@/shared/ui';

type SupplierValue = Pick<
  ProductionOrderSheetFields,
  'supplierName' | 'supplierContact' | 'supplierPhone' | 'supplierEmail'
>;

interface SupplierFieldsProps {
  readonly value: SupplierValue;
  readonly onChange: (value: SupplierValue) => void;
}

/** 발주서 수신 업체 칸 — 업체명·담당자·연락처·이메일. */
export const SupplierFields = ({ value, onChange }: SupplierFieldsProps): ReactElement => (
  <div className="grid gap-4 sm:grid-cols-2">
    <FormField
      label="업체명"
      maxLength={MAX_PRODUCTION_ORDER_SHEET_TEXT_LENGTH}
      value={value.supplierName}
      onChange={(event) => onChange({ ...value, supplierName: event.target.value })}
    />
    <FormField
      label="담당자"
      maxLength={MAX_PRODUCTION_ORDER_SHEET_TEXT_LENGTH}
      value={value.supplierContact}
      onChange={(event) => onChange({ ...value, supplierContact: event.target.value })}
    />
    <FormField
      label="연락처"
      type="tel"
      maxLength={MAX_PRODUCTION_ORDER_SHEET_TEXT_LENGTH}
      value={value.supplierPhone}
      onChange={(event) => onChange({ ...value, supplierPhone: event.target.value })}
    />
    <FormField
      label="이메일"
      type="email"
      maxLength={MAX_PRODUCTION_ORDER_SHEET_TEXT_LENGTH}
      value={value.supplierEmail}
      onChange={(event) => onChange({ ...value, supplierEmail: event.target.value })}
    />
  </div>
);
